import { http } from ".."
import { appSearchProps } from "./search-interface"

/**
 * Search app
 * @param data Object
 * @returns search data 
 */
export const appSearch = (data: appSearchProps) => {
  return http.get('/search', {
    params: {
      ...data
    }
  })
}